import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AppComponent } from './app.component';
import { NavigationPaths } from './commons/config/navigation-paths.enum';
import { AboutComponent } from './views/about/about.component';
import { ClassesComponent } from './views/classes/classes.component';
import { HomeComponent } from './views/home/home.component';
import { StaffComponent } from './views/staff/staff.component';

const routes: Routes = [
  {
    path: '',
    component: AppComponent,
    children: [
      {
        path: '',
        component: HomeComponent,
      },
      {
        path: NavigationPaths.ABOUT_US,
        component: AboutComponent
      },
      {
        path: NavigationPaths.CLASSES,
        component: ClassesComponent
      },
      {
        path: NavigationPaths.STAFF,
        component: StaffComponent
      },
      {
        path: NavigationPaths.ENROLLMENT,
        loadChildren: () => import('./views/enrollment/enrollment.module').then(m => m.EnrollmentModule)
      },
      {
        path: NavigationPaths.LOGIN,
        loadChildren: () => import('./views/login/login.module').then(m => m.LoginModule)
      },
      {
        path: NavigationPaths.USER_COURSES,
        loadChildren: () => import('./views/user-courses/user-courses.module').then(m => m.UserCoursesModule)
      }
    ]
  },
  { path: '**', redirectTo: '' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
